import React from 'react';
import Divider from 'widgets/Divider';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import './CheckoutSuccess.scss';

function Success() {
  return (
    <div className="Checkout__Success">
      <div>
        <div className="Checkout__Success__Content">
          <div className="Checkout__Success__Heading"><FormattedMessage id="views.CheckoutSuccess.success.heading" /></div>
          <div className="Checkout__Success__Body">
            <div>
              <FormattedMessage id="views.CheckoutSuccess.success.body" />
            </div>
            <Divider
              style={{
                backgroundColor: '#cecece',
                margin: '20px 0'
              }}
            />

            <div className="Checkout__Success__Body__Guide">
              <div className="Checkout__Success__Body__Guide__Title">
                <FormattedMessage id="views.CheckoutSuccess.success.body.guide.title" />
              </div>

              <div className="Checkout__Success__Body__Guide__StepsWrap">

                <div className="Checkout__Success__Body__Guide__StepsWrap__Step--1">
                  <div>
                    <span className="Checkout__Success__Body__Guide__StepsWrap__Step__Num">
                      <FormattedMessage id="views.CheckoutSuccess.success.body.guide.step1.num" />
                    </span>

                    <div className="DetailsWrap">
                      <div className="Checkout__Success__Body__Guide__StepsWrap__Step__Text">
                        <span>
                          <FormattedMessage id="views.CheckoutSuccess.success.body.guide.step1.text" />
                        </span>
                      </div>

                      <div className="Checkout__Success__Body__Store__Links">
                        <div className="Checkout__Success__Body__Store__Links__ImgWrap">
                          <a
                            href="https://itunes.apple.com/ca/app/muse-brain-sensing-headband/id849841170?mt=8"
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            <img alt="apple store" src="/images/apple_store.png" />
                          </a>
                        </div>
                        <div className="Checkout__Success__Body__Store__Links__ImgWrap">
                          <a
                            href="https://play.google.com/store/apps/details?id=com.interaxon.muse&hl=en_CA"
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            <img alt="play store" src="/images/google_play.png" />
                          </a>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div className="Checkout__Success__Body__Guide__StepsWrap__Step--2">
                  <div>
                    <span className="Checkout__Success__Body__Guide__StepsWrap__Step__Num">
                      <FormattedMessage id="views.CheckoutSuccess.success.body.guide.step2.num" />
                    </span>

                    <div className="DetailsWrap">
                      <div className="Checkout__Success__Body__Guide__StepsWrap__Step__Text">
                        <span>
                          <FormattedMessage id="views.CheckoutSuccess.success.body.guide.step2.text" />
                        </span>
                      </div>
                      <div className="Details">
                        <FormattedHTMLMessage id="views.CheckoutSuccess.success.body.guide.step2.details" />
                      </div>
                    </div>
                  </div>
                </div>

                <img className="Checkout__Success__Image__TabletOnly" src="/images/activate_success_phone.gif" alt="mobile" width="194px" height="auto" />
              </div>
            </div>
          </div>
        </div>
        <div className="Checkout__Success__Image">
          <img src="/images/activate_success_phone.gif" alt="mobile" width="194px" height="auto" />
        </div>
      </div>
    </div>
  );
}

export default Success;



// WEBPACK FOOTER //
// ./src/views/CheckoutSuccess/CheckoutSuccess.jsx